<template>
  <v-dialog
    :value="showDialog"
    width="70%"
    min-height="800px"
    @input="showDialog = false"
    @cancel="closeDialog"
  >
    <qr-scanner @decode="decodeQr" :isFullScrenOnStart="false" :visible="qrScannerVisible" :isMultiScaner="isMultiScaner" @cancel="closeDialog" />
  </v-dialog>
</template>

<script>
export default {
  components: {
    'qr-scanner': () => import('@it-enterprise/web-app-common/src/widgets/dr-qr-code/components/qr-scanner.vue')
  },

  data: () => ({
    showDialog: false,
    qrScannerVisible: false,
    isMultiScaner: false
  }),

  mounted() {
    this.$emit('mounted')
  },

  methods: {
    decodeQr(code) {
      this.showDialog = false
      this.qrScannerVisible = false
      this.$options.popupController.resolve(code)
    },

    closeDialog() {
      this.showDialog = false
      this.qrScannerVisible = false
      this.$options.popupController.resolve(null)
    },
    scan() {
      let resolve
      let reject

      const popupPromise = new Promise((ok, fail) => {
        resolve = ok
        reject = fail
      })

      this.$options.popupController = { resolve, reject }
      this.showDialog = true
      this.qrScannerVisible = true
      return popupPromise
    },
    multiScan() {
      this.isMultiScaner = true
      return this.scan()
    }
  }
}
</script>